import { IntlShape } from 'react-intl';
import { TableFiltersState } from '../../../../utils/table-filters/filter-table-types';
import { initialFilters } from '../../../../utils/table-filters/const';

export const initialFilterTableState: TableFiltersState = {
  filterAnchorElement: null,
  filters: { ...initialFilters }
};

export const translatedOptions = (intl: IntlShape) => [
  { id: 'invoice', name: intl.formatMessage({ id: 'predict.invoices', defaultMessage: 'Invoices' }) },
  { id: 'bill', name: intl.formatMessage({ id: 'predict.bills', defaultMessage: 'Bills' }) }
];
